module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leon Morris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Leon Morris")]), _vm._v(" (1914-2006) was one of Australia's most prolific Bible scholars. He wrote over forty other books, including commentaries on Matthew, John, and Thessalonians.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xIzIzp/tc-custom/9781467451444.jpg?1737194764094",
      "alt": "This image is the cover for the book The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this now-classic commentary, first published in 1988 in the Pillar New Testament Commentary series, noted biblical scholar Leon Morris unravels Romans and the complexities of faith and interpretation associated with the epistle.")]), _c('p', [_vm._v("In his introduction Morris deals with matters of authorship, destination, date, occasion, and contents in a brief but helpful way. The commentary proper consists of careful verse-by-verse exposition of the text along with full and informative footnotes. Though he interacts considerably with the immense body of literature on Romans, Morris’s approach to the study of the epistle remains clearly his own. His thorough exegesis enables readers to understand Romans as one of the greatest and most spiritually significant books in the Bible.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0